import { ControlledSelect } from "@dune/ui";
import {
	duneContactCreationSubRoles,
	duneContactCreationSubRolesLabels,
} from "@dune/vars";
import { useFormContext } from "react-hook-form";
import { ContactFormData } from "./useAddContactForm";

export const DuneContactForm = () => {
	const formMethods = useFormContext<ContactFormData>();
	const {
		control,
		formState: { errors },
	} = formMethods;

	return (
		<>
			<ControlledSelect
				control={control}
				name="duneSubRole"
				label="Rôle"
				options={duneContactCreationSubRoles.map((subrole) => ({
					label: duneContactCreationSubRolesLabels[subrole],
					value: subrole,
				}))}
				placeholder="Sélectionner"
				required
				error={errors.duneSubRole?.message}
			/>
		</>
	);
};
